import React,{useRef} from 'react';
import Landing from './components/landing/index';
import Login from './components/auth/login';
import Signup from './components/auth/signup';
import Event from './components/event/event';
import Listing from './components/event/create/listing/listing';
import Create from './components/event/create/create';
import Mediator from './components/mediator/mediator';
import CreateAvatar from './components/avatar/avatar';
import Join from './components/event/join/join';
import Participants from './components/event/join/participants';
import Audience from './components/event/join/audience';
import ChooseSide from './components/event/join/choose_side';
import CountDown from './components/loader/counter';
import Subscription from './components/subscription/subscription';
import { BrowserRouter as Router, Route,Routes} from "react-router-dom";
import { AuthProvider } from './redux/actions/JWTAuth_action';
import { useDispatch } from "react-redux";
import { useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import  secureLocalStorage  from  "react-secure-storage";
import { WebsocketProvider } from './websocket/context';
import WinnerAnnouncement from './components/loader/counter';
import Payment from './components/subscription/strip';
// import Checkout from './components/subscription/checkout';
import Completion from './components/subscription/completion';




function App() {
  const isMounted = useRef(false);
  const dispatch = useDispatch();
  useEffect(()=>{
    if (isMounted.current) return;
    dispatch(AuthProvider()); 
    isMounted.current = true;
    // let start = secureLocalStorage.getItem("pause")
    // if (start === null){
    //   secureLocalStorage.setItem("pause",true);
    // }

  },[]);


  

  return (
    <div className='App'>
      <ToastContainer position="top-right"/>
      {/* <Checkout/> */}

    <Router>
      <Routes>
        <Route exact path="/" element={ <Landing/> }/>
        <Route exact path="/login" element={ <Login/> }/>
        <Route exact path="/signup" element={ <Signup/> }/>
        <Route exact path="/event" element={ <Event/> }/>
        <Route exact path="/debates" element={ <Listing/> }/>
        <Route exact path="/create" element={ <Create/> }/>
        <Route exact path="/mediator" element={<WebsocketProvider><Mediator/></WebsocketProvider>}/>
        <Route exact path='/choose' element={<WebsocketProvider><ChooseSide/></WebsocketProvider> }/>
        <Route exact path="/participants" element={<WebsocketProvider><Participants/></WebsocketProvider>  }/>
        <Route exact path="/audience" element={<WebsocketProvider><Audience/></WebsocketProvider>} />
        <Route exact path="/avatar" element={ <CreateAvatar/> }/>
        <Route exact path="/join" element={ <Join/> }/>
        <Route exact path='/winner' element={ <WinnerAnnouncement/>}/>
        <Route exact path='/subscription' element={ <Subscription/>}/>
        <Route exact path='/checkout' element={<Payment/>}/>
        <Route exact path='/completion' element={<Completion/>}/>



      </Routes>
    </Router>
   
    </div>
    
  );
}

export default App;
